<script setup>
import { useI18n } from 'vue-i18n';
import FlowIframeLoader from 'dashboard/components/widgets/FlowIframeLoader.vue';

const { t } = useI18n();

// Toda pagina do Flow embutida no Chat vive sob /chat (pro: pages/chat/*), entao o caminho
// carrega o prefixo. Path ABSOLUTO de proposito: resolve a partir da origem do FLOW_BASE_URL,
// funcionando tanto com `https://flow.winker.com.br` quanto com `.../chat` no fim da variavel.
const flowBaseUrl = window.chatwootConfig?.flowBaseUrl;
const url = flowBaseUrl
  ? new URL('/chat/personal?tab=runtime', flowBaseUrl).toString()
  : '';
</script>

<template>
  <div class="h-full w-full flex flex-col flex-1 overflow-hidden gap-4 pb-6">
    <div class="p-5">
      <span class="text-xl font-medium text-n-slate-12">{{
        t('SIDEBAR.TICKETS')
      }}</span>
    </div>
    <div class="-ml-4 h-full overflow-y-auto">
      <div class="w-full h-full min-h-0 px-6">
        <FlowIframeLoader :url="url" />
      </div>
    </div>
  </div>
</template>
